import { Plugins, FilesystemDirectory } from "@capacitor/core";

export async function download(type) {
  await Plugins.Filesystem.mkdir({
    directory: FilesystemDirectory.ExternalStorage,
    path: "/acapella"
  }).catch(console.log);
  return Plugins.Filesystem.copy({
    directory: FilesystemDirectory.ExternalStorage,
    from: `output.${type}`,
    toDirectory: FilesystemDirectory.ExternalStorage,
    to: `/acapella/acapella-${Date.now()}.${type}`,
    
  })
}
